import { render, staticRenderFns } from "./SourcesCopyToSelect.vue?vue&type=template&id=472a08a0&scoped=true"
import script from "./SourcesCopyToSelect.vue?vue&type=script&lang=js"
export * from "./SourcesCopyToSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472a08a0",
  null
  
)

export default component.exports